import {
  Box,
  Button,
  IconButton,
  Modal,
  Typography,
  TextField,
} from "@mui/material";
import { Dispatch, SetStateAction, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

type props = {
  openModal: boolean;
  setOpenModal: Dispatch<SetStateAction<boolean>>;
  text: string;
  handleSubmit: (reason?: string) => void;
  reject?: boolean;
};

export const ConfirmationModal = ({
  openModal,
  setOpenModal,
  text,
  handleSubmit,
  reject,
}: props) => {
  const [reason, setReason] = useState("");
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  const handleYes = () => {
    if (reject) {
      setShow(true);
      setReason(""); // Clear reason
    } else {
      handleSubmit();
      setOpenModal(false);
    }
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "#ffff",
    boxShadow: 24,
    p: 6,
    borderRadius: 3,
    outline: "none",
  };
  const closed = () => {
    setOpenModal(false);
    setShow(false);
  };

  const onReject = () => {
    setError(true);
    if (reason != "") {
      handleSubmit(reason);
      closed();
    }
  };
  return (
    <Modal open={openModal} onClose={() => closed()} className="logout_mdl">
      <Box sx={style}>
        <IconButton
          onClick={() => closed()}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "#252525",
          }}
        >
          <CloseIcon />
        </IconButton>

        <Typography
          variant="h6"
          component="h2"
          sx={{ textAlign: "center", fontSize: "20px", color: "#1d2b28" }}
        >
          {text}
        </Typography>

        {show ? (
          <div
            style={{
              paddingTop: "20px",
            }}
          >
            <TextField
              placeholder="Reason for rejection"
              fullWidth
              multiline
              minRows={3}
              value={reason}
              className="text_field"
              onChange={(e) => setReason(e.target.value)}
              sx={{ marginTop: 2 }}
              helperText={error && reason == "" ? "Please add a reason" : ""}
              inputProps={{ maxLength: 250 }}
            />
            <div
              style={{
                paddingTop: 20,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Button
                className="btn btn_blue"
                sx={{ minWidth: "100px" }}
                onClick={() => onReject()}
              >
                Submit
              </Button>
            </div>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              gap: "30px",
              justifyContent: "center",
              paddingTop: "20px",
            }}
          >
            <Button
              className="btn btn_blue"
              sx={{ minWidth: "100px" }}
              onClick={handleYes}
              // disabled={reject && reason.trim() === ""}
            >
              Yes
            </Button>

            <Button
              className="btn btn_blue"
              sx={{ minWidth: "100px" }}
              onClick={() => setOpenModal(false)}
            >
              No
            </Button>
          </div>
        )}
      </Box>
    </Modal>
  );
};
